/* eslint-disable max-lines-per-function */
import "./return-request.scss";

const initReturnReasonSelect = () => {
  const reasonSelect = document.getElementById("request_return_reason");
  if (!reasonSelect) return;

  const note = document.getElementById("js-return-request-delivery-note");

  reasonSelect.addEventListener("change", () => {
    note.classList.toggle("hidden", reasonSelect.value !== "7- Order shipped too late");
  });
};

const initSelectAllButton = () => {
  const selectAll = document.getElementById("select-all-button");
  if (!selectAll) return;

  selectAll.addEventListener("click", () => {
    const checkbox = $("#request-return__select-all-checkbox");
    if (!checkbox) return;

    checkbox.click();
  });

  const selectLabel = document.getElementById("request-return__select-all-label");
  if (!selectLabel) return;

  selectLabel.addEventListener("click", () => {
    const checkbox = $("#request-return__select-all-checkbox");
    if (!checkbox) return;

    checkbox.click();
  });
};

const initSelectAllCheckbox = () => {
  const checkbox = document.getElementById("request-return__select-all-checkbox");
  if (!checkbox) return;

  checkbox.addEventListener("change", () => {
    $(".return-items__item-return-input").each(function f() {
      if (checkbox.checked) {
        $(this).val($(this).attr("max"));
      } else {
        $(this).val("");
      }
    });
  });
};

document.addEventListener("DOMContentLoaded", () => {
  initReturnReasonSelect();
  initSelectAllButton();
  initSelectAllCheckbox();
});
